import { useTranslation } from "react-i18next";
import FunctionalButton from "components/layout/FunctionalButton";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import BehaviourProfilesPanel from "components/navigation/mission/BehaviourProfilesPanel";
import { useMissionControl } from "providers/navigation/MissionProvider";

import { ReactComponent as CloseIcon } from "assets/svgs/Minus.svg";

const BehaviourControlPanel = ({ visible = false }) => {
    const { t } = useTranslation("missions");
    const { setShowBehaviourInControl } = useMissionControl();

    const handleClose = () => setShowBehaviourInControl(false);

    return (
        <AnimatedModal
            visible={visible}
            onClose={handleClose}
            zIndexClassName="z-[120]"
            className="flex max-h-[90vh] w-[30.75rem] min-h-0 flex-col overflow-hidden rounded-r10 bg-black90 px-2 py-4"
        >
            <div className="mb-2 flex w-full shrink-0 items-center justify-between">
                <p className="h4l font-bold">{t("behaviour.title")}</p>
                <FunctionalButton
                    icon={<CloseIcon className="w-4" />}
                    className="h-6 w-6 rounded-r3 hover:bg-black70"
                    onClick={handleClose}
                />
            </div>
            <div className="scroll-vertical mt-2 flex min-h-0 flex-1 flex-col overflow-y-auto">
                <BehaviourProfilesPanel />
            </div>
        </AnimatedModal>
    );
};

export default BehaviourControlPanel;
